import { render, staticRenderFns } from "./DragDialog.vue?vue&type=template&id=6daf5c17&scoped=true"
import script from "./DragDialog.vue?vue&type=script&lang=js"
export * from "./DragDialog.vue?vue&type=script&lang=js"
import style0 from "./DragDialog.vue?vue&type=style&index=0&id=6daf5c17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf5c17",
  null
  
)

export default component.exports